export { default } from './svg-store-landing';
